module.exports = __webpack_public_path__ + "img/to1do.fda30bd4.png";